import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';
import { createWrapper } from 'next-redux-wrapper';

// кидаем ошибку при мутации хранилища
// для дев окружения
function freezeMiddleware(store) {
    const deepFreeze = require('deep-freeze');
    deepFreeze(store);
    return next => action => {
        deepFreeze(store);
        try {
            return next(action);
        } finally {
            deepFreeze(store);
        }
    };
}

const makeStore = () => {
    const middleware = [
        thunk,
    ];

    let enhancer;
    if (process.env.ENVIROMENT === 'localhost') {
        const { composeWithDevTools } = require('redux-devtools-extension');
        enhancer = composeWithDevTools;
        middleware.push(freezeMiddleware);
    } else {
        enhancer = compose;
    }

    return createStore(rootReducer, enhancer(applyMiddleware(...middleware)));
};

export const wrapper = createWrapper(makeStore, { debug: false });
